import { useState } from "react"
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";

export const useConfiguracoesEventosFinanceiro = () => {
    const [loading, setLoading] = useState(false);
    const api = ApiFactory.getApi('MS_FINANCEIRO');
    const notificar = useSnackbar();

    const listarConfiguracoes = async (evento: string) => {
        setLoading(true);

        try {
            const { data } = await api.get(`/eventos/configuracoes/${evento}`);
            return data;
        } catch (error) {
            notificar("Ocorreu um erro ao listar as configurações", { severity: 'error' })
        } finally {
            setLoading(false);
        }
    }

    const criarConfiguracao = async (email: string, evento: string) => {
        setLoading(true);

        try {
            const { data } = await api.post(`/eventos/configuracoes/${evento}`, { email });
            notificar("Configuração criada com sucesso", { severity: 'success' });
            return data;
        } catch (error) {
            notificar("Ocorreu um erro ao cadastrar a configuração", { severity: 'error' });
        } finally {
            setLoading(false);
        }
    }

    const excluirConfiguracao = async (uuid: string) => {
        setLoading(true);

        try {
            const { data } = await api.delete(`/eventos/configuracoes/${uuid}`);
            notificar("Configuração excluída com sucesso", { severity: 'success' });
            return data;
        } catch (error) {
            notificar("Ocorreu um erro ao excluir a configuração", { severity: 'error' });
        } finally {
            setLoading(false);
        }
    }

    return { listarConfiguracoes, criarConfiguracao, loading, excluirConfiguracao }
}